
import React from 'react';
import classnames from 'classnames';
// import { Radio } from 'antd';
import { ChartsTabKey, AdContentTabKey, BenchmarkTabKey } from '@store/overviewDashboard/kpiData/reducer';
import { useDispatch, useSelector } from 'react-redux';
import { activeTabSelector } from '@store/overviewDashboard/kpiData/selectors';
import { setActiveTab } from '@store/overviewDashboard/kpiData/actions';

import TimeseriesIcon from '@icons/ovb/timeseries.svg';
import DistributionIcon from '@icons/ovb/distribution.svg';
import BenchmarkIcon from '@icons/ovb/benchmark.svg';
import { unifiedAdContentOverviewSelector, hasBenchmarkSelector } from '@store/common/selectors';
import { ToggleWrapper, IconWrap, ButtonGroup } from './styled';

function Toggle() {
  const dispatch = useDispatch();
  const hasBenchmarkFlag = useSelector(hasBenchmarkSelector);
  const unifiedAdContentOverview = useSelector(unifiedAdContentOverviewSelector);
  const selectedOption = useSelector(activeTabSelector);

  const handleChange: any = key => () => {
    dispatch(setActiveTab(key));
  };

  return (
    <ToggleWrapper>
      <ButtonGroup>
        <div
          className={classnames({ selected: selectedOption === ChartsTabKey })}
          onClick={handleChange(ChartsTabKey)}
        >
          <IconWrap>
            <TimeseriesIcon id="TimeseriesIcon" />
          </IconWrap>
        </div>
        {unifiedAdContentOverview
          // FF control
          && (
            <div
              className={classnames({ selected: selectedOption === AdContentTabKey })}
              onClick={handleChange(AdContentTabKey)}
            >
              <IconWrap>
                <DistributionIcon id="DistributionIcon" />
              </IconWrap>
            </div>
          )
        }
        {
          (hasBenchmarkFlag)
            && (
              <div
                className={classnames({ selected: selectedOption === BenchmarkTabKey })}
                onClick={handleChange(BenchmarkTabKey)}
              >
                <IconWrap>
                  <BenchmarkIcon id="BenchmarkIcon" />
                </IconWrap>
              </div>
            )
        }
      </ButtonGroup>
    </ToggleWrapper>
  );
}

export default Toggle;
